module.exports = __webpack_public_path__ + "img/chalom_no.bf577277.png";